import { render, staticRenderFns } from "./DefaultTable.vue?vue&type=template&id=38f43dd8&scoped=true"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"
import style0 from "./DefaultTable.vue?vue&type=style&index=0&id=38f43dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f43dd8",
  null
  
)

export default component.exports